import * as Uppy from './src/index.ts'

globalThis.Uppy = Uppy
